import React from "react";
const SvgMagnifyingGlass = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#1A1F24" fillRule="evenodd" clipRule="evenodd">
      <path d="M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 1a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
      <path d="M15.146 15.146a.5.5 0 01.708 0l5 5a.5.5 0 01-.708.708l-5-5a.5.5 0 010-.708z" />
    </g>
  </svg>
);
export default SvgMagnifyingGlass;
